import { render, staticRenderFns } from "./ChatBody.vue?vue&type=template&id=81816cc6&"
import script from "./ChatBody.vue?vue&type=script&lang=js&"
export * from "./ChatBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports